import { httpClient } from '../api/http-client';

export interface Proveedor {
  id: string;
  nombre: string;
  nit?: string;
  telefono?: string;
  email?: string;
  direccion?: string;
  contacto?: string;
  activo: boolean;
  creadoEn: string;
  actualizadoEn: string;
}

export interface PaginatedSuppliersResponse {
  data: {
    data: Proveedor[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
  };
}

export class SuppliersService {
  private static readonly BASE_PATH = '/suppliers';

  static async list(page: number = 1, limit: number = 20, search?: string): Promise<PaginatedSuppliersResponse> {
    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('limit', String(limit));
    if (search) params.append('search', search);
    const response = await httpClient.get<PaginatedSuppliersResponse>(`${this.BASE_PATH}?${params.toString()}`);
    return response.data;
  }

  static async getById(id: string): Promise<{ success: boolean; data: Proveedor; message?: string }> {
    const response = await httpClient.get<{ success: boolean; data: Proveedor }>(`${this.BASE_PATH}/${id}`);
    return response.data;
  }

  static async create(data: Omit<Proveedor, 'id' | 'creadoEn' | 'actualizadoEn'>): Promise<{ success: boolean; data: Proveedor; message?: string }> {
    const response = await httpClient.post<{ success: boolean; data: Proveedor }>(this.BASE_PATH, data);
    return response.data;
  }

  static async update(id: string, data: Partial<Omit<Proveedor, 'id' | 'creadoEn' | 'actualizadoEn'>>): Promise<{ success: boolean; data: Proveedor; message?: string }> {
    const response = await httpClient.put<{ success: boolean; data: Proveedor }>(`${this.BASE_PATH}/${id}`, data);
    return response.data;
  }

  static async delete(id: string): Promise<{ success: boolean; message?: string }> {
    const response = await httpClient.delete<{ success: boolean }>(`${this.BASE_PATH}/${id}`);
    return response.data;
  }

  static async getAllForSelect(): Promise<{ success: boolean; data: Proveedor[] }> {
    const response = await httpClient.get<{ success: boolean; data: Proveedor[] }>(`${this.BASE_PATH}/select/all`);
    return response.data;
  }
}
